import Model from "@ember-data/model";

export default class TimedTransaction extends Model {
  constructor(
    public name: string,
    public startDate: Date,
    public endDate?: Date,
    public success?: boolean,
    public error?: { name: string; message: string }
  ) {
    super();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "timed-transaction": TimedTransaction;
  }
}
